"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTimes = exports.stepsFor = exports.to12h = exports.to24h = exports.is12h = exports.is24h = void 0;
const leftPad = (str) => String(str).length < 2 ? `0${str}` : String(str);
const is24h = (time) => !/\s+(a|p)m/i.test(time);
exports.is24h = is24h;
const is12h = (time) => /\s+(a|p)m/i.test(time);
exports.is12h = is12h;
const to24h = (time) => {
    if ((0, exports.is24h)(time))
        return time;
    const [hours, minutes, marker] = time.split(/:|\s/);
    if (marker === 'pm' && Number(hours) === 12) {
        return `12:${minutes}`;
    }
    else if (marker === 'am' && Number(hours) === 12) {
        return `00:${minutes}`;
    }
    else if (marker === 'pm') {
        return `${Number(hours) + 12}:${minutes}`;
    }
    else {
        return `${hours}:${minutes}`;
    }
};
exports.to24h = to24h;
const to12h = (time) => {
    if ((0, exports.is12h)(time))
        return time;
    const [hours, minutes] = time.split(/:|\s/).map(Number);
    const marker = hours < 12 ? 'AM' : 'PM';
    return `${hours === 0 ? 12 : hours <= 12 ? hours : hours - 12}:${leftPad(minutes)} ${marker}`;
};
exports.to12h = to12h;
const stepsFor = (hour, offset, step, endMinute = 0) => {
    // if endMinute is present we exclude time afterwards
    // otherwise we're working with a full hour
    const excludedTime = endMinute ? 60 - endMinute : 0;
    // create steps for this portion of time
    const minutesInHour = 60 - excludedTime;
    // create increments starting at the given offset
    const baseIncrements = Math.round(minutesInHour / step);
    const incrementsOffset = Math.round(offset / step);
    const steps = baseIncrements - incrementsOffset;
    return Array.from({ length: steps }).map((_, idx) => (0, exports.to12h)(`${hour}:${leftPad(idx * step + offset)}`));
};
exports.stepsFor = stepsFor;
const generateTimes = ({ start, end, step = 15 }) => {
    const [startHour, startMinute] = (0, exports.to24h)(start).split(':').map(Number);
    const [endHour, endMinute] = (0, exports.to24h)(end).split(':').map(Number);
    // if there are endMinutes, increment endHour by 1
    // so steps spill into the next hour slot vs stopping
    // at the end of the previous hour
    const endHourRoundedUp = endMinute ? endHour + 1 : endHour;
    // basically this is range(startHours, endHours) but
    // ecma didn't think we needed a range function
    const hours = Array.from({ length: endHourRoundedUp - startHour }, (_, idx) => idx + startHour);
    return hours.reduce((timesList, hour) => timesList.concat(
    // if the first hour starts with an offset (i.e. the clinic opens at 9:30), pass
    // the offset so `stepsFor` can account for it. otherwise, chop up the whole hour.
    ...(0, exports.stepsFor)(hour, hour === startHour ? startMinute : 0, step, hour === endHour ? endMinute : 0)), []);
};
exports.generateTimes = generateTimes;
//# sourceMappingURL=helpers.js.map